<template>
    <v-card class="services elevation-6" shaped>
        <v-card-title>
            <h4 style="word-break: break-word;">
                Dental Care
            </h4>
        </v-card-title>
        <v-divider />
        <v-container>
            <h5 style="word-break: break-word;">
                For members with dental services added to their plan, oral care is just
                a phone call away.
            </h5>
            <v-btn
                small
                class="teal accent-4 white--text my-4"
                @click="showDental = !showDental"
            >
                Read more
            </v-btn>
        </v-container>

        <!-- DIALOG BOX -->

        <Dental :show-dental="showDental" @showDialog="showDentalDialog" />
    </v-card>
</template>

<script>
import Dental from '../DialogBoxes/Dental.vue'
export default {
    components: { Dental },
    data: () => ({ showDental: false }),
    methods: {
        showDentalDialog(showDental) {
            this.showDental = showDental
        }
    }
}
</script>

<style scoped>
.services {
  text-align: justify;
  width: 250px;
}
.services h5 {
  font-weight: normal;
}
@media (max-width: 599px) {
  .services {
    margin-top: 20px;
    width: 95%;
  }
}
@media (min-width: 599px) and (max-width: 1904px) {
  .services {
    margin-top: 15px;
    width: 45%;
  }
}
</style>
